import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildingThick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13 0H3v2H1v14h2v-4h2v4h2v-4h2v4h2v-4h2v4h2V2h-2zM9 4H7v2h2zM7 8h2v2H7zM5 4H3v2h2zM3 8h2v2H3zm10-4h-2v2h2zm-2 4h2v2h-2z",
		clipRule: "evenodd"
	})
});
export default SvgBuildingThick;
